import React, { Component } from 'react';
import {
  ListaProdutividadeDetalhadaDashboard,
  ListaVendedoresAtivos,
  ListaVendasClientes,
  ListaRankingAnual,
  runVerificaAutenticacao,
  ListaTelasCRM
} from '../../../services/api';
import $ from 'jquery';
import Header from '../../../components/Header';
import {
  BoxRanking,
  BoxRankingContainer,
  BoxRankingContainerGoal,
  BoxRankingContainerGoalPlace,
  Clientes,
  ContainerContentDashboard,
  ContainerDash,
  ContainerDashHeader,
  ContentDashboard,
  ContentDashboardContainer,
  ContentDashboardContainerClientes,
  ContentDashboardContainerPreFixo,
  ContentDashboardContainerTwo,
  ContentDashboardLoading,
  ContentDashboardLoadingContent,
  ContentHeaderFilter,
  ContentHeaderFilterContainer,
  ContentHeaderFilterContainerBox,
  ContentHeaderFilterContainerBoxFilter,
  ContentHeaderFilterContainerBoxFilterSelect,
  ContentHeaderFilterContainerBoxFilterTimeLine,
  DashboardContainerBash,
  DashboardContainerBashBody,
  DashboardContainerBashBodyBarProgress,
  DashboardContainerBashBodyBarProgressClientes,
  DashboardContainerBashBodyBarProgressPedidos,
  DashboardContainerBashBodyProgress,
  DashboardContainerBashHeader,
  DashboardContainerBashHeaderTitle,
  DashboardContainerBashHeaderTitleClientes,
  DashboardContainerBashHeaderTitleCustom,
  DashBoardProdutividadeDetalhadaContainer,
  DashBoardProdutividadeDetalhadaContainerText,
  DashBoardProdutividadeDetalhadaContent,
  DashClientes,
  ImageRanking,
  ProgressClientes,
  ProgressPedidos,
  SelectBox,
  SelectVendedor,
  Text2,
  TimeLine,
  TitleClientes
} from './styles';
import { Box, Image, Select, Text } from '@chakra-ui/react';
import { ImageLoading } from '../../Site/ImagemProduto/styles';
import { user } from '../../../helpers/user';
import { ModalRevenue } from './ModalRevenue';

const loading = '/images/loading.gif';

const codUsersByRevenue = {
  0: '0',
  30: '30',
  21: '21'
};

const meses = {
  1: 'Jan.',
  2: 'Fev.',
  3: 'Mar.',
  4: 'Abr.',
  5: 'Mai.',
  6: 'Jun.',
  7: 'Jul.',
  8: 'Ago.',
  9: 'Set.',
  10: 'Out.',
  11: 'Nov.',
  12: 'Dez.'
};

class DashboardProdutividadeDetalhada extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dados: [],
      dadosCliente: [],
      vendedores: [],
      dadosRanking: [],
      meses_faltantes: [],
      periodo_selecionado: new Date().getFullYear(),
      usuario_selecionado: null,
      loading: false,
      pedido_ano: 0,
      ticket_medio_ano: 0,
      proposta_enviadas_ano: 0,
      perdidos_ano: 0,
      novos_chamados_ano: 0,
      ligacoes_efetuadas_ano: 0,
      ligacoes_recebidas_ano: 0,
      emails_encaminhadas_ano: 0,
      meta_ranking_vendas_ano: 0,
      meta_ranking_pedido_ano: 0,
      codigo_usuario: JSON.parse(localStorage.getItem('authentication')).codigo_usuario,
      codigo_vendedor: JSON.parse(localStorage.getItem('authentication')).codigo_vendedor,

      control_inclusao: null,
      control_alteracao: null,
      control_exclusao: null,
      control_consulta: null,
      media_vendas: 0,
      media_pedidos: 0
    };
  }

  componentDidMount() {
    runVerificaAutenticacao();
    this.initial();
  }

  initial = async () => {
    await this.CarregaPermissoes();
    if ([0, 30, 22, 21, 14, 12].includes(this.state.codigo_usuario)) {
      this.getConfig();
    } else {
      this.getVendedores();
      this.getRankingAnual();
      this.getData();
    }
  };

  getConfig = async () => {
    const queryParams = new URLSearchParams(window.location.search);

    const vendedor = queryParams.get('v');

    await this.getVendedores();

    if (vendedor != null) {
      $('#selectVendedor').val(vendedor);
      await this.setState({ usuario_selecionado: vendedor });
    }

    this.getRankingAnual();
    this.getData();
  };

  CarregaPermissoes = async () => {
    try {
      const response = await ListaTelasCRM.get('/' + window.location.pathname.replace('/', ''));
      var data = await response.data;

      var codigo_tela = null;
      for (var obj in data) {
        codigo_tela = obj;
      }

      await this.setState({
        codigo_tela: codigo_tela,
        control_inclusao: JSON.parse(localStorage.getItem('authentication')).permissoes_usuario[
          codigo_tela
        ].inclusao,
        control_alteracao: JSON.parse(localStorage.getItem('authentication')).permissoes_usuario[
          codigo_tela
        ].alteracao,
        control_exclusao: JSON.parse(localStorage.getItem('authentication')).permissoes_usuario[
          codigo_tela
        ].exclusao,
        control_consulta: JSON.parse(localStorage.getItem('authentication')).permissoes_usuario[
          codigo_tela
        ].consulta
      });
    } catch (error) {
      console.log(Object.keys(error), error.message);
    }
  };

  getRankingAnual = async () => {
    if (this.state.control_consulta != 'S') {
      alert('Permissão negada');
      return false;
    }

    try {
      var codigo_usuario =
        this.state.usuario_selecionado == null
          ? this.state.codigo_usuario
          : this.state.usuario_selecionado;
      var ano_selecionado = this.state.periodo_selecionado;

      console.log('ANO SELECIONADO: ' + ano_selecionado);

      const responseRanking = await ListaRankingAnual.get(
        '/' + ano_selecionado + '/' + codigo_usuario
      );
      var dataRanking = responseRanking.data;

      await this.setState({ dadosRanking: dataRanking });
    } catch (error) {
      console.log(Object.keys(error), error.message);
    }
  };

  getData = async () => {
    if (this.state.control_consulta != 'S') {
      alert('Permissão negada');
      return false;
    }

    try {
      this.setState({ loading: true });

      var param = {
        codigo_usuario:
          this.state.usuario_selecionado == null
            ? this.state.codigo_usuario
            : this.state.usuario_selecionado,
        ano_selecionado: this.state.periodo_selecionado
      };
      console.log(param);
      const response = await ListaProdutividadeDetalhadaDashboard.post('', param);
      var data = response.data;

      console.log('data', data);

      console.log(response);

      var codigo_usuario =
        this.state.usuario_selecionado == null
          ? this.state.codigo_usuario
          : this.state.usuario_selecionado;
      var ano_selecionado = this.state.periodo_selecionado;

      const responseClientes = await ListaVendasClientes.get(
        '/' + ano_selecionado + '/' + codigo_usuario
      );
      var dataClientes = responseClientes.data;

      var vendas_cliente_total = 0;
      dataClientes.map((data) => {
        vendas_cliente_total = vendas_cliente_total + parseFloat(data.total_pedidos);
      });

      var vendas_ano = 0;
      var pedido_ano = 0;
      var ticket_medio_ano = 0;
      var proposta_enviadas_ano = 0;
      var perdidos_ano = 0;
      var novos_chamados_ano = 0;
      var ligacoes_efetuadas_ano = 0;
      var ligacoes_recebidas_ano = 0;
      var emails_encaminhadas_ano = 0;
      var meta_ranking_vendas_ano = 0;
      var meta_ranking_pedido_ano = 0;
      data.map((data) => {
        vendas_ano = vendas_ano + parseFloat(data.vendas_mes);
        pedido_ano = pedido_ano + parseFloat(data.total_pedidos);
        ticket_medio_ano =
          ticket_medio_ano + parseFloat(data.ticket_medio == null ? 0 : data.ticket_medio);
        proposta_enviadas_ano =
          proposta_enviadas_ano + parseFloat(data.proposta_encaminhada_qtde_mes);
        perdidos_ano = perdidos_ano + parseFloat(data.proposta_perdida_qtde_mes);
        novos_chamados_ano = novos_chamados_ano + parseFloat(data.novos_chamados_total_qtde_mes);
        ligacoes_efetuadas_ano =
          ligacoes_efetuadas_ano + parseFloat(data.telefone_efetuada_qtde_mes);
        ligacoes_recebidas_ano =
          ligacoes_recebidas_ano + parseFloat(data.telefone_recebida_qtde_mes);
        emails_encaminhadas_ano = emails_encaminhadas_ano + parseFloat(data.emails_qtde_mes);
        meta_ranking_vendas_ano = data.meta_ranking_ano;
        meta_ranking_pedido_ano = data.meta_ranking_pedido_ano;
      });

      let meses_faltantes = [];

      var date = new Date();
      if (String(this.state.periodo_selecionado) === String(date.getFullYear())) {
        var mes = Number(date.getMonth() + 1);

        meses_faltantes = Array.from({ length: mes - parseInt(data.length) }, (_, i) => i + 1);

        const calculoMediaVendas = Number(new Date().getMonth() + 1) - meses_faltantes.length;

        this.setState({
          media_vendas: parseFloat(vendas_ano / calculoMediaVendas).toLocaleString('pt-BR', {
            minimumFractionDigits: 2
          }),
          media_pedidos: parseFloat(pedido_ano / calculoMediaVendas).toLocaleString('pt-BR', {
            minimumFractionDigits: 2
          })
        });
      } else {
        var mes = 12;

        const calculoMediaVendas = parseFloat(vendas_ano / 12).toLocaleString('pt-BR', {
          minimumFractionDigits: 2
        });

        this.setState({
          media_vendas: calculoMediaVendas,
          media_pedidos: parseFloat(pedido_ano / 12).toLocaleString('pt-BR', {
            minimumFractionDigits: 2
          })
        });
      }

      console.log('mes', mes);

      console.log('data.length', data.length);

      // {parseFloat(
      //   vendas_ano /
      //     (Number(new Date().getMonth() + 1) -
      //       this.state.meses_faltantes.length)
      // ).toLocaleString('pt-BR', { minimumFractionDigits: 2 })}

      // parseFloat(
      //   pedido_ano /
      //     (Number(new Date().getMonth() + 1) -
      //       this.state.meses_faltantes.length)
      // ).toLocaleString('pt-BR', { minimumFractionDigits: 2 })

      meses_faltantes = Array.from({ length: mes - parseInt(data.length) }, (_, i) => i + 1);

      if (String(this.state.periodo_selecionado) !== String(date.getFullYear())) {
        meses_faltantes = [];
      }

      this.setState({
        dados: data,
        dadosCliente: dataClientes,
        meses_faltantes: meses_faltantes,
        vendas_ano: vendas_ano,
        pedido_ano: pedido_ano,
        ticket_medio_ano: ticket_medio_ano,
        proposta_enviadas_ano: proposta_enviadas_ano,
        perdidos_ano: perdidos_ano,
        novos_chamados_ano: novos_chamados_ano,
        ligacoes_efetuadas_ano: ligacoes_efetuadas_ano,
        ligacoes_recebidas_ano: ligacoes_recebidas_ano,
        emails_encaminhadas_ano: emails_encaminhadas_ano,
        vendas_cliente_ano: vendas_cliente_total,
        meta_ranking_vendas_ano: meta_ranking_vendas_ano,
        meta_ranking_pedido_ano: meta_ranking_pedido_ano
      });
      this.setState({ loading: false });
    } catch (error) {
      this.setState({ loading: false });
      console.log(Object.keys(error), error.message);
    }
  };

  getVendedores = async () => {
    try {
      const response = await ListaVendedoresAtivos.get();
      var data = response.data;

      var vendedores = [];
      vendedores.push({ value: 0, label: 'GERAL' });
      data.map((data) => {
        vendedores.push({
          value: data.codigo_usuario,
          label: data.nome_vendedor
        });
      });

      this.setState({ vendedores: vendedores });
    } catch (error) {
      console.log(Object.keys(error), error.message);
    }
  };

  selectPeriodo = async (e) => {
    var option = e.target.options[e.target.options.selectedIndex].value;
    console.log(option);
    await this.setState({ periodo_selecionado: option });
    this.getRankingAnual();
    this.getData();
  };

  selectUsuario = async (e) => {
    var option = e.target.options[e.target.options.selectedIndex].value;
    await this.setState({ usuario_selecionado: option });
    this.getRankingAnual();
    this.getData();
  };

  render() {
    const {
      dados,
      dadosCliente,
      meses_faltantes,
      dadosRanking,
      vendedores,
      vendas_ano,
      pedido_ano,
      ticket_medio_ano,
      proposta_enviadas_ano,
      perdidos_ano,
      novos_chamados_ano,
      ligacoes_efetuadas_ano,
      ligacoes_recebidas_ano,
      emails_encaminhadas_ano,
      meta_ranking_vendas_ano,
      meta_ranking_pedido_ano
    } = this.state;

    const date = new Date();
    console.log(date);
    const ano_atual = date.getFullYear();
    const anos = Array.from({ length: ano_atual - 2015 + 1 }, (_, i) => i + 2015);

    return (
      <>
        <DashBoardProdutividadeDetalhadaContainer>
          <DashBoardProdutividadeDetalhadaContainerText>
            <h1>
              DASHBOARD <strong>PRODUTIVIDADE DETALHADA</strong>
            </h1>
          </DashBoardProdutividadeDetalhadaContainerText>
          <DashBoardProdutividadeDetalhadaContent>
            {!this.state.loading && codUsersByRevenue[this.state.codigo_usuario] && (
              <Box mx="auto" display="flex" alignItems="center" justifyContent="center" py={2}>
                <ModalRevenue />
              </Box>
            )}
            <ContentHeaderFilter>
              <ContentHeaderFilterContainer>
                <ContentHeaderFilterContainerBox>
                  <ContentHeaderFilterContainerBoxFilter>
                    <ContentHeaderFilterContainerBoxFilterSelect>
                      <label>
                        CHAMADOS ABERTOS <strong> {pedido_ano + perdidos_ano}</strong>
                      </label>
                      <Box align="center">
                        <label style={{ color: '#ffbd37' }}>ANO:</label>
                        <SelectBox
                          mt="-2.1rem"
                          w="100px"
                          bgColor="white"
                          color="gray.100"
                          iconColor="#404042"
                          variant="outline"
                          focusBorderColor="#404042"
                          _hover={{ borderBottomColor: '#404042' }}
                          _active={{ borderBottomColor: '#404042' }}
                          onChange={(e) => this.selectPeriodo(e)}
                          defaultValue={anos[anos.length - 1]}
                          value={this.state.periodo_selecionado}>
                          {anos.map((data) => {
                            return <option value={String(data)}>{data}</option>;
                          })}
                        </SelectBox>
                      </Box>
                    </ContentHeaderFilterContainerBoxFilterSelect>

                    {[0, 30, 22, 21, 14, 12].includes(this.state.codigo_usuario) ? (
                      <SelectVendedor>
                        <SelectBox
                          w="170px"
                          bgColor="white"
                          iconColor="#404042"
                          fontSize="20px"
                          variant="outline"
                          focusBorderColor="#404042"
                          _hover={{ borderBottomColor: '#404042' }}
                          _active={{ borderBottomColor: '#404042' }}
                          placeholder="Vendedores..."
                          id="selectVendedor"
                          onChange={(e) => this.selectUsuario(e)}>
                          {vendedores.map((data) => {
                            return <option value={data.value}>{data.label}</option>;
                          })}
                        </SelectBox>
                      </SelectVendedor>
                    ) : (
                      <></>
                    )}
                  </ContentHeaderFilterContainerBoxFilter>
                  <TimeLine>
                    <div className="green">
                      <label>
                        Pedidos fechados: <strong> {pedido_ano}</strong>
                      </label>
                      <BarProgress
                        completed={
                          Math.round((pedido_ano * 100) / (pedido_ano + perdidos_ano)) > 100
                            ? 100
                            : Math.round((pedido_ano * 100) / (pedido_ano + perdidos_ano))
                        }
                        label={
                          Math.round((pedido_ano * 100) / (pedido_ano + perdidos_ano)) > 100
                            ? 100
                            : Math.round((pedido_ano * 100) / (pedido_ano + perdidos_ano)) + '%'
                        }
                        bgcolor={'#17b35d'}
                      />
                    </div>
                  </TimeLine>
                  <TimeLine>
                    <div className="red">
                      <label>
                        Chamados perdidos: <strong> {perdidos_ano}</strong>
                      </label>
                      <BarProgress
                        completed={
                          Math.round((perdidos_ano * 100) / (pedido_ano + perdidos_ano)) > 100
                            ? 100
                            : Math.round((perdidos_ano * 100) / (pedido_ano + perdidos_ano))
                        }
                        label={
                          Math.round((perdidos_ano * 100) / (pedido_ano + perdidos_ano)) > 100
                            ? 100
                            : Math.round((perdidos_ano * 100) / (pedido_ano + perdidos_ano)) + '%'
                        }
                        bgcolor={'#eb4424'}
                      />
                    </div>
                  </TimeLine>
                </ContentHeaderFilterContainerBox>
                <ContentHeaderFilterContainerBox>
                  <BoxRanking>
                    <BoxRankingContainer>
                      <p>VENDAS ACUMULADAS</p>
                      <>
                        <BoxRankingContainerGoalPlace>
                          <ImageRanking
                            marginLeft="1.5rem"
                            alt="icon_place"
                            src="../images/icon_place.png"
                          />
                          {meta_ranking_vendas_ano}º lugar
                        </BoxRankingContainerGoalPlace>

                        <h6>
                          <Text as="sup" color="#FD9044" fontSize="sm">
                            R$
                          </Text>
                          {parseFloat(vendas_ano).toLocaleString('pt-BR', {
                            minimumFractionDigits: 2
                          })}
                        </h6>
                      </>
                      <h5>
                        Média:{' '}
                        <Text as="sup" color="gray" fontSize="sx">
                          R$
                        </Text>
                        {this.state.media_vendas}
                      </h5>
                    </BoxRankingContainer>
                    <BoxRankingContainer>
                      <p>PEDIDOS ACUMULADOS</p>
                      <BoxRankingContainerGoal>
                        <BoxRankingContainerGoalPlace>
                          <ImageRanking
                            marginLeft="0.5rem"
                            alt="icon_place"
                            src="../images/icon_place.png"
                          />
                          {meta_ranking_pedido_ano}º lugar
                        </BoxRankingContainerGoalPlace>
                      </BoxRankingContainerGoal>
                      <h4>{pedido_ano}</h4>
                      <h5>Média: {parseInt(this.state.media_pedidos)?.toFixed(2)}</h5>
                    </BoxRankingContainer>
                  </BoxRanking>
                </ContentHeaderFilterContainerBox>
              </ContentHeaderFilterContainer>
            </ContentHeaderFilter>
            <ContainerContentDashboard>
              <ContentDashboardLoading
                style={this.state.loading ? { display: 'block' } : { display: 'none' }}>
                <ContentDashboardLoadingContent>
                  <Image alt="loading" src={loading} />
                </ContentDashboardLoadingContent>
              </ContentDashboardLoading>

              <ContentDashboardContainer>
                <ContentDashboardContainerPreFixo>
                  <div className="line"></div>
                  <div className="line"></div>
                  <div className="line">
                    <h1>JANEIRO</h1>
                  </div>
                  <div className="line">
                    <h1>FEVEREIRO</h1>
                  </div>
                  <div className="line">
                    <h1>MARÇO</h1>
                  </div>
                  <div className="line">
                    <h1>ABRIL</h1>
                  </div>
                  <div className="line">
                    <h1>MAIO</h1>
                  </div>
                  <div className="line">
                    <h1>JUNHO</h1>
                  </div>
                  <div className="line">
                    <h1>JULHO</h1>
                  </div>
                  <div className="line">
                    <h1>AGOSTO</h1>
                  </div>
                  <div className="line">
                    <h1>SETEMBRO</h1>
                  </div>
                  <div className="line">
                    <h1>OUTUBRO</h1>
                  </div>
                  <div className="line">
                    <h1>NOVEMBRO</h1>
                  </div>
                  <div className="line">
                    <h1>DEZEMBRO</h1>
                  </div>
                </ContentDashboardContainerPreFixo>

                <DashboardContainerBash>
                  <DashboardContainerBashHeader>
                    <DashboardContainerBashHeaderTitle>
                      <h1>VENDAS</h1>
                      <h6>
                        <Text as="sup" color="#f68e4a" fontSize="sm">
                          R$
                        </Text>
                        {parseFloat(vendas_ano).toLocaleString('pt-BR', {
                          minimumFractionDigits: 2
                        })}
                        <strong style={{ color: '#f68e4a', float: 'right' }}></strong>
                      </h6>
                    </DashboardContainerBashHeaderTitle>
                  </DashboardContainerBashHeader>
                  <DashboardContainerBashBody>
                    {meses_faltantes.map((data) => {
                      return (
                        <DashboardContainerBashBodyProgress>
                          <BarProgress completed={0} label={'R$ 0,00'} bgcolor={'#f68e4a'} />
                          <p style={{ color: '#f68e4a' }}>0º</p>
                        </DashboardContainerBashBodyProgress>
                      );
                    })}
                    {dados.map((data, idx) => {
                      return (
                        <DashboardContainerBashBodyProgress>
                          <BarProgress
                            completed={
                              Math.round((data.vendas_mes * 100) / parseFloat(data.vendas_ano)) >
                              100
                                ? 100
                                : Math.round((data.vendas_mes * 100) / parseFloat(data.vendas_ano))
                            }
                            label={parseFloat(data.vendas_mes).toLocaleString('pt-BR', {
                              style: 'currency',
                              currency: 'BRL'
                            })}
                            bgcolor={'#f68e4a'}
                          />
                          <p style={{ color: '#f68e4a' }}>
                            {dadosRanking.length == dados.length
                              ? dadosRanking[idx].ranking_vendas_mes
                              : 0}
                            º
                          </p>
                        </DashboardContainerBashBodyProgress>
                      );
                    })}
                  </DashboardContainerBashBody>
                </DashboardContainerBash>

                <DashboardContainerBash>
                  <DashboardContainerBashHeader>
                    <DashboardContainerBashHeaderTitle>
                      <h1>PEDIDOS</h1>
                      <p>
                        <strong
                          style={{
                            color: '#16b25d',
                            float: 'right'
                          }}>
                          {pedido_ano}
                        </strong>
                      </p>
                    </DashboardContainerBashHeaderTitle>
                  </DashboardContainerBashHeader>
                  <DashboardContainerBashBody>
                    {meses_faltantes.map((data) => {
                      return (
                        <DashboardContainerBashBodyProgress>
                          <p>{meses[data]}</p>
                          <BarProgressPedidos completed={0} label={0} bgcolor={'#16b25d'} />
                          <h1 style={{ color: '#16b25d' }}>0º</h1>
                        </DashboardContainerBashBodyProgress>
                      );
                    })}
                    {dados.map((data, idx) => {
                      return (
                        <DashboardContainerBashBodyBarProgressPedidos>
                          <p>{meses[meses_faltantes.length + idx + 1]}</p>
                          <BarProgressPedidos
                            completed={
                              Math.round(
                                (data.total_pedidos * 100) / parseFloat(data.pedidos_ano)
                              ) > 100
                                ? 100
                                : Math.round(
                                    (data.total_pedidos * 100) / parseFloat(data.pedidos_ano)
                                  )
                            }
                            label={data.total_pedidos}
                            bgcolor={'#16b25d'}
                          />
                          <h1 style={{ color: '#16b25d' }}>
                            {dadosRanking.length == dados.length
                              ? dadosRanking[idx].ranking_pedido_mes
                              : 0}
                            º
                          </h1>
                        </DashboardContainerBashBodyBarProgressPedidos>
                      );
                    })}
                  </DashboardContainerBashBody>
                </DashboardContainerBash>

                <DashboardContainerBash>
                  <DashboardContainerBashHeader>
                    <DashboardContainerBashHeaderTitle>
                      <DashboardContainerBashHeaderTitleCustom>
                        <h1>TICKET MÉDIO</h1>
                        <h6>
                          <Text as="sup" color="#8f7dba" fontSize="sm">
                            R$
                          </Text>
                          {parseFloat(
                            parseFloat(vendas_ano) / parseFloat(pedido_ano)
                          ).toLocaleString('pt-BR', {
                            minimumFractionDigits: 2
                          })}
                          <strong style={{ color: '#8f7dba', float: 'right' }}></strong>
                        </h6>
                      </DashboardContainerBashHeaderTitleCustom>
                    </DashboardContainerBashHeaderTitle>
                  </DashboardContainerBashHeader>
                  <DashboardContainerBashBody>
                    {meses_faltantes.map((data) => {
                      return (
                        <DashboardContainerBashBodyProgress>
                          <p>{meses[data]}</p>
                          <BarProgress completed={0} label={'R$ 0,00'} bgcolor={'#8f7dba'} />
                        </DashboardContainerBashBodyProgress>
                      );
                    })}
                    {dados.map((data, idx) => {
                      {
                        console.log('data', data);
                      }
                      return (
                        <DashboardContainerBashBodyProgress>
                          <p>{meses[meses_faltantes.length + idx + 1]}</p>
                          <BarProgress
                            completed={
                              Math.round((data.ticket_medio * 100) / parseFloat(ticket_medio_ano)) >
                              100
                                ? 100
                                : Math.round(
                                    (data.ticket_medio * 100) / parseFloat(ticket_medio_ano)
                                  )
                            }
                            label={parseFloat(data.vendas_mes / data.total_pedidos).toLocaleString(
                              'pt-BR',
                              {
                                style: 'currency',
                                currency: 'BRL'
                              }
                            )}
                            bgcolor={'#8f7dba'}
                          />
                        </DashboardContainerBashBodyProgress>
                      );
                    })}
                  </DashboardContainerBashBody>
                </DashboardContainerBash>

                <DashboardContainerBash>
                  <DashboardContainerBashHeader>
                    <DashboardContainerBashHeaderTitle>
                      <h1>PROPOSTAS ENVIADAS</h1>
                      <p>
                        <strong style={{ color: '#cfa32f', float: 'right' }}>
                          {proposta_enviadas_ano}
                        </strong>
                      </p>
                    </DashboardContainerBashHeaderTitle>
                  </DashboardContainerBashHeader>
                  <DashboardContainerBashBody>
                    {meses_faltantes.map((data) => {
                      return (
                        <DashboardContainerBashBodyProgress>
                          <p>{meses[data]}</p>
                          <BarProgress completed={0} label={0} bgcolor={'#cfa32f'} />
                        </DashboardContainerBashBodyProgress>
                      );
                    })}
                    {dados.map((data, idx) => {
                      return (
                        <DashboardContainerBashBodyProgress>
                          <p>{meses[meses_faltantes.length + idx + 1]}</p>
                          <BarProgress
                            completed={
                              Math.round(
                                (data.proposta_encaminhada_qtde_mes * 100) /
                                  parseFloat(proposta_enviadas_ano)
                              ) > 100
                                ? 100
                                : Math.round(
                                    (data.proposta_encaminhada_qtde_mes * 100) /
                                      parseFloat(proposta_enviadas_ano)
                                  )
                            }
                            label={data.proposta_encaminhada_qtde_mes}
                            bgcolor={'#cfa32f'}
                          />
                        </DashboardContainerBashBodyProgress>
                      );
                    })}
                  </DashboardContainerBashBody>
                </DashboardContainerBash>

                <DashboardContainerBash>
                  <DashboardContainerBashHeader>
                    <DashboardContainerBashHeaderTitle>
                      <h1>PERDIDOS</h1>
                      <p>
                        <strong style={{ color: '#ec4524', float: 'right' }}>{perdidos_ano}</strong>
                      </p>
                    </DashboardContainerBashHeaderTitle>
                  </DashboardContainerBashHeader>
                  <DashboardContainerBashBody>
                    {meses_faltantes.map((data) => {
                      return (
                        <DashboardContainerBashBodyProgress>
                          <p>{meses[data]}</p>
                          <BarProgress completed={0} label={0} bgcolor={'#ec4524'} />
                        </DashboardContainerBashBodyProgress>
                      );
                    })}
                    {dados.map((data, idx) => {
                      return (
                        <DashboardContainerBashBodyProgress>
                          <p>{meses[meses_faltantes.length + idx + 1]}</p>
                          <BarProgress
                            completed={
                              Math.round(
                                (data.proposta_perdida_qtde_mes * 100) / parseFloat(perdidos_ano)
                              ) > 100
                                ? 100
                                : Math.round(
                                    (data.proposta_perdida_qtde_mes * 100) /
                                      parseFloat(perdidos_ano)
                                  )
                            }
                            label={data.proposta_perdida_qtde_mes}
                            bgcolor={'#ec4524'}
                          />
                        </DashboardContainerBashBodyProgress>
                      );
                    })}
                  </DashboardContainerBashBody>
                </DashboardContainerBash>
              </ContentDashboardContainer>
            </ContainerContentDashboard>

            <ContainerContentDashboard>
              <ContentDashboardContainerTwo>
                <ContentDashboardContainerPreFixo>
                  <div className="line"></div>
                  <div className="line"></div>
                  <div className="line">
                    <h1>JANEIRO</h1>
                  </div>
                  <div className="line">
                    <h1>FEVEREIRO</h1>
                  </div>
                  <div className="line">
                    <h1>MARÇO</h1>
                  </div>
                  <div className="line">
                    <h1>ABRIL</h1>
                  </div>
                  <div className="line">
                    <h1>MAIO</h1>
                  </div>
                  <div className="line">
                    <h1>JUNHO</h1>
                  </div>
                  <div className="line">
                    <h1>JULHO</h1>
                  </div>
                  <div className="line">
                    <h1>AGOSTO</h1>
                  </div>
                  <div className="line">
                    <h1>SETEMBRO</h1>
                  </div>
                  <div className="line">
                    <h1>OUTUBRO</h1>
                  </div>
                  <div className="line">
                    <h1>NOVEMBRO</h1>
                  </div>
                  <div className="line">
                    <h1>DEZEMBRO</h1>
                  </div>
                </ContentDashboardContainerPreFixo>

                <DashboardContainerBash>
                  <DashboardContainerBashHeader>
                    <DashboardContainerBashHeaderTitle>
                      <h1>NOVOS CHAMADOS</h1>
                      <p>
                        <strong style={{ color: '#3f6aac', float: 'right' }}>
                          {novos_chamados_ano}
                        </strong>
                      </p>
                    </DashboardContainerBashHeaderTitle>
                  </DashboardContainerBashHeader>
                  <DashboardContainerBashBody>
                    {meses_faltantes.map((data) => {
                      return (
                        <DashboardContainerBashBodyProgress>
                          <BarProgress completed={0} label={0} bgcolor={'#3f6aac'} />
                          <p style={{ color: '#3f6aac' }}></p>
                        </DashboardContainerBashBodyProgress>
                      );
                    })}
                    {dados.map((data, idx) => {
                      return (
                        <DashboardContainerBashBodyProgress>
                          <BarProgress
                            completed={
                              Math.round(
                                (data.novos_chamados_total_qtde_mes * 100) /
                                  parseFloat(novos_chamados_ano)
                              ) > 100
                                ? 100
                                : Math.round(
                                    (data.novos_chamados_total_qtde_mes * 100) /
                                      parseFloat(novos_chamados_ano)
                                  )
                            }
                            label={data.novos_chamados_total_qtde_mes}
                            bgcolor={'#3f6aac'}
                          />
                          <p style={{ color: '#3f6aac' }}></p>
                        </DashboardContainerBashBodyProgress>
                      );
                    })}
                  </DashboardContainerBashBody>
                </DashboardContainerBash>

                <DashboardContainerBash>
                  <DashboardContainerBashHeader>
                    <DashboardContainerBashHeaderTitle>
                      <h1>LIGAÇÕES EFETUADAS</h1>
                      <p>
                        <strong style={{ color: '#67a5b5', float: 'right' }}>
                          {ligacoes_efetuadas_ano}
                        </strong>
                      </p>
                    </DashboardContainerBashHeaderTitle>
                  </DashboardContainerBashHeader>
                  <DashboardContainerBashBody>
                    {meses_faltantes.map((data) => {
                      return (
                        <DashboardContainerBashBodyProgress>
                          <p>{meses[data]}</p>
                          <BarProgress completed={0} label={0} bgcolor={'#67a5b5'} />
                        </DashboardContainerBashBodyProgress>
                      );
                    })}
                    {dados.map((data, idx) => {
                      return (
                        <DashboardContainerBashBodyProgress>
                          <p>{meses[meses_faltantes.length + idx + 1]}</p>
                          <BarProgress
                            completed={
                              Math.round(
                                (data.telefone_efetuada_qtde_mes * 100) /
                                  parseFloat(ligacoes_efetuadas_ano)
                              ) > 100
                                ? 100
                                : Math.round(
                                    (data.telefone_efetuada_qtde_mes * 100) /
                                      parseFloat(ligacoes_efetuadas_ano)
                                  )
                            }
                            label={data.telefone_efetuada_qtde_mes}
                            bgcolor={'#67a5b5'}
                          />
                        </DashboardContainerBashBodyProgress>
                      );
                    })}
                  </DashboardContainerBashBody>
                </DashboardContainerBash>

                <DashboardContainerBash>
                  <DashboardContainerBashHeader>
                    <DashboardContainerBashHeaderTitle>
                      <h1>LIGAÇÕES RECEBIDAS</h1>
                      <p>
                        <strong style={{ color: '#7c7a79', float: 'right' }}>
                          {ligacoes_recebidas_ano}
                        </strong>
                      </p>
                    </DashboardContainerBashHeaderTitle>
                  </DashboardContainerBashHeader>
                  <DashboardContainerBashBody>
                    {meses_faltantes.map((data) => {
                      return (
                        <DashboardContainerBashBodyProgress>
                          <p>{meses[data]}</p>
                          <BarProgress completed={0} label={0} bgcolor={'#7c7a79'} />
                        </DashboardContainerBashBodyProgress>
                      );
                    })}
                    {dados.map((data, idx) => {
                      return (
                        <DashboardContainerBashBodyProgress>
                          <p>{meses[meses_faltantes.length + idx + 1]}</p>
                          <BarProgress
                            completed={
                              Math.round(
                                (data.telefone_recebida_qtde_mes * 100) /
                                  parseFloat(ligacoes_recebidas_ano)
                              ) > 100
                                ? 100
                                : Math.round(
                                    (data.telefone_recebida_qtde_mes * 100) /
                                      parseFloat(ligacoes_recebidas_ano)
                                  )
                            }
                            label={data.telefone_recebida_qtde_mes}
                            bgcolor={'#7c7a79'}
                          />
                        </DashboardContainerBashBodyProgress>
                      );
                    })}
                  </DashboardContainerBashBody>
                </DashboardContainerBash>

                <DashboardContainerBash>
                  <DashboardContainerBashHeader>
                    <DashboardContainerBashHeaderTitle>
                      <h1>E-MAILS ENCAMINHADOS</h1>
                      <p>
                        <strong style={{ color: '#c4ce28', float: 'right' }}>
                          {emails_encaminhadas_ano}
                        </strong>
                      </p>
                    </DashboardContainerBashHeaderTitle>
                  </DashboardContainerBashHeader>
                  <DashboardContainerBashBody>
                    {meses_faltantes.map((data) => {
                      return (
                        <DashboardContainerBashBodyProgress>
                          <p>{meses[data]}</p>
                          <BarProgress completed={0} label={0} bgcolor={'#c4ce28'} />
                        </DashboardContainerBashBodyProgress>
                      );
                    })}
                    {dados.map((data, idx) => {
                      return (
                        <DashboardContainerBashBodyProgress>
                          <p>{meses[meses_faltantes.length + idx + 1]}</p>
                          <BarProgress
                            completed={
                              Math.round(
                                (data.emails_qtde_mes * 100) / parseFloat(emails_encaminhadas_ano)
                              ) > 100
                                ? 100
                                : Math.round(
                                    (data.emails_qtde_mes * 100) /
                                      parseFloat(emails_encaminhadas_ano)
                                  )
                            }
                            label={data.emails_qtde_mes}
                            bgcolor={'#c4ce28'}
                          />
                        </DashboardContainerBashBodyProgress>
                      );
                    })}
                  </DashboardContainerBashBody>
                </DashboardContainerBash>
              </ContentDashboardContainerTwo>

              <ContentDashboardContainerClientes>
                <DashClientes>
                  <ContainerDashHeader>
                    <TitleClientes>
                      <h1>VENDAS POR CLIENTE</h1>
                      <h6>
                        <Text as="sup" color="#a05178" fontSize="sm">
                          R$
                        </Text>
                        {parseFloat(vendas_ano).toLocaleString('pt-BR', {
                          minimumFractionDigits: 2
                        })}
                        <strong style={{ color: '#8f7dba', float: 'right' }}></strong>
                      </h6>
                    </TitleClientes>
                  </ContainerDashHeader>
                  <DashboardContainerBashBody>
                    {dadosCliente.map((data, idx) => {
                      return (
                        <ProgressClientes>
                          <p>
                            {data.nome_parceiro.trim().length > 10
                              ? data.nome_parceiro.trim().substr(0, 10) + '...'
                              : data.nome_parceiro.trim()}
                          </p>
                          <BarProgressClientes
                            completed={parseFloat(data.percentual_total_vendas)}
                            label={Math.round(parseFloat(data.percentual_total_vendas)) + '%'}
                            bgcolor={'#a05178'}
                          />
                          <h1>{parseInt(data.quantidade_pedido)}</h1>
                        </ProgressClientes>
                      );
                    })}
                  </DashboardContainerBashBody>
                </DashClientes>
              </ContentDashboardContainerClientes>
            </ContainerContentDashboard>
          </DashBoardProdutividadeDetalhadaContent>
        </DashBoardProdutividadeDetalhadaContainer>
      </>
    );
  }
}

function BarProgress(data) {
  if (data.completed < 3) {
    var progress = 3;
  } else {
    var progress = data.completed;
  }

  if (data.bgcolor != undefined) {
    var bgcolor = data.bgcolor;
  } else {
    var bgcolor = '#12A499';
  }

  if (data.border == 1) {
    var borderLeft = '15px';
    var borderRight = '15px';
  } else {
    var borderLeft = '15px';
    var borderRight = '0px';
  }

  if (data.completed == 100) {
    var borderLeft = '15px';
    var borderRight = '15px';
  }

  return (
    <DashboardContainerBashBodyBarProgress>
      <div
        style={{
          width: progress + '%',
          backgroundColor: bgcolor,
          borderTopLeftRadius: borderLeft,
          borderBottomLeftRadius: borderLeft,
          borderTopRightRadius: borderRight,
          borderBottomRightRadius: borderRight
        }}
        className="progress"></div>
      <div style={{ color: 'white' }} className="value">
        {data.label !== undefined ? (
          <p style={data.completed > 90 ? { color: 'black' } : { color: 'black' }}>{data.label}</p>
        ) : (
          <p style={{ color: 'white' }}>
            {!isNaN(Number(data.completed.toFixed(1))) ? Number(data.completed.toFixed(1)) : 0}%
          </p>
        )}
      </div>
    </DashboardContainerBashBodyBarProgress>
  );
}
function BarProgressClientes(data) {
  if (data.completed < 3) {
    var progress = 3;
  } else {
    var progress = data.completed;
  }

  if (data.bgcolor != undefined) {
    var bgcolor = data.bgcolor;
  } else {
    var bgcolor = '#12A499';
  }

  if (data.border == 1) {
    var borderLeft = '15px';
    var borderRight = '15px';
  } else {
    var borderLeft = '15px';
    var borderRight = '0px';
  }

  if (data.completed == 100) {
    var borderLeft = '15px';
    var borderRight = '15px';
  }

  return (
    <DashboardContainerBashBodyBarProgressClientes>
      <div
        style={{
          width: progress + '%',
          backgroundColor: bgcolor,
          borderTopLeftRadius: borderLeft,
          borderBottomLeftRadius: borderLeft,
          borderTopRightRadius: borderRight,
          borderBottomRightRadius: borderRight
        }}
        className="progress"></div>
      <div className="value">
        {data.label != undefined ? (
          <p style={data.completed > 90 ? { color: 'white' } : {}}>{data.label}</p>
        ) : (
          <p>
            {!isNaN(Number(data.completed.toFixed(1))) ? Number(data.completed.toFixed(1)) : 0}%
          </p>
        )}
      </div>
    </DashboardContainerBashBodyBarProgressClientes>
  );
}
function BarProgressPedidos(data) {
  if (data.completed < 3) {
    var progress = 3;
  } else {
    var progress = data.completed;
  }

  if (data.bgcolor != undefined) {
    var bgcolor = data.bgcolor;
  } else {
    var bgcolor = '#12A499';
  }

  if (data.border == 1) {
    var borderLeft = '15px';
    var borderRight = '15px';
  } else {
    var borderLeft = '15px';
    var borderRight = '0px';
  }

  if (data.completed == 100) {
    var borderLeft = '15px';
    var borderRight = '15px';
  }

  return (
    <ProgressPedidos>
      <div
        style={{
          width: progress + '%',
          backgroundColor: bgcolor,
          borderTopLeftRadius: borderLeft,
          borderBottomLeftRadius: borderLeft,
          borderTopRightRadius: borderRight,
          borderBottomRightRadius: borderRight
        }}
        className="progress"></div>
      <div className="value">
        {data.label != undefined ? (
          <p style={data.completed > 90 ? { color: 'white' } : {}}>{data.label}</p>
        ) : (
          <p>
            {!isNaN(Number(data.completed.toFixed(1))) ? Number(data.completed.toFixed(1)) : 0}%
          </p>
        )}
      </div>
    </ProgressPedidos>
  );
}

export default DashboardProdutividadeDetalhada;
